import React, {ReactNode, useRef} from 'react';
import {Button} from '~/components/Button';
import {IntentText} from '~/components/Form';
import {IMenuItemProps, Menu} from '~/components/Menu';
import {useAbility} from '~/lib/ability';
import {Intent} from '~/lib/intent';
import {PaymentsAbility} from '~/modules/Payments/ability';
import {getPaymentStatusLabel, PaymentStatus} from '~/modules/Payments/models/Payment';

export const paymentIntentByStatus = {
    [PaymentStatus.RECEIVED]: Intent.WARNING,
    [PaymentStatus.PAID]: Intent.SUCCESS,
    [PaymentStatus.REJECTED]: Intent.DANGER,
};

interface IPaymentStatusMenuProps {
    status: PaymentStatus;
    onChange: (paymentStatus: PaymentStatus, reason?: string) => void;
}

export const PaymentStatusMenu = ({status, onChange}: IPaymentStatusMenuProps) => {
    const ability = useAbility(PaymentsAbility);
    const items: IMenuItemProps[] = [];

    const menuItemForStatus = (paymentStatus: PaymentStatus, icon?: ReactNode, onClick?: () => void) => ({
        children: getPaymentStatusLabel(paymentStatus),
        icon: icon,
        intent: paymentIntentByStatus[paymentStatus],
        onClick: onClick ? onClick : () => onChange(paymentStatus)
    });

    if (PaymentStatus.RECEIVED === status) {
        items.push(menuItemForStatus(PaymentStatus.PAID, <i className='fa fa-dollar'/>));
    }

    if (status !== PaymentStatus.REJECTED) {
        items.push(menuItemForStatus(PaymentStatus.REJECTED, <i className='fa fa-close'/>, () => {
            const reason = prompt('Reason');
            if (reason) {
                onChange(PaymentStatus.REJECTED, reason);
            }
        }));
    }

    const buttonRef = useRef();
    return <>
        {items.length > 0 && ability.canChangeStatus() ? <>
            <Button ref={buttonRef}
                intent={paymentIntentByStatus[status]}
                small
                leftIcon={<i className='fa fa-pencil'/>}>
                {getPaymentStatusLabel(status)}
            </Button>
            {items.length > 0 && <Menu items={items} parentRef={buttonRef}/>}
        </> : <IntentText intent={paymentIntentByStatus[status]}>{getPaymentStatusLabel(status)}</IntentText>}
    </>;
};
